export const validateFlowStructure = (screens = [], { isDynamic = false } = {}) => {
  const errors = [];

  if (!Array.isArray(screens) || screens.length === 0) {
    errors.push('Flow must have at least one screen');
    return errors;
  }

  const screenIds = screens.map((screen) => screen.id).filter(Boolean);
  if (screenIds.length !== new Set(screenIds).size) {
    errors.push('All screen IDs must be unique');
  }

  if (screens.length > 20) {
    errors.push('Maximum 20 screens allowed per flow');
  }

  screens.forEach((screen, index) => {
    if (!screen.title?.trim()) {
      errors.push(`Screen ${index + 1} must have a title`);
    }

    if (!screen.components?.length) {
      errors.push(`Screen ${index + 1} must have at least one component`);
    }

    const buttons = screen.components?.filter((c) => c.type === 'button') || [];
    if (buttons.length > 3) {
      errors.push(`Screen ${index + 1} can have maximum 3 buttons`);
    }

    const navigationLists =
      screen.components?.filter((c) => c.type === 'navigation_list') || [];
    if (navigationLists.length > 1) {
      errors.push(`Screen ${index + 1} can have only 1 navigation list`);
    }

    screen.components?.forEach((component) => {
      if (component.type === 'navigation_list') {
        if (component.data_mode === 'dynamic') {
          if (!component.data_source_key?.trim()) {
            errors.push(`Navigation list in screen ${index + 1} needs an API data key`);
          }
        } else if (!component.items?.length) {
          errors.push(`Navigation list in screen ${index + 1} must have at least 1 item`);
        }
      }

      if (component.type === 'radio' || component.type === 'dropdown') {
        if (component.data_mode === 'dynamic') {
          if (!component.data_source_key?.trim()) {
            errors.push(`${component.type} in screen ${index + 1} needs an API data key`);
          }
        } else if (!component.options || component.options.length < 2) {
          errors.push(
            `${component.type} in screen ${index + 1} must have at least 2 options`
          );
        }
      }
      if (component.type === 'checkbox') {
        if (component.data_mode === 'dynamic') {
          if (!component.data_source_key?.trim()) {
            errors.push(`Checkbox in screen ${index + 1} needs an API data key`);
          }
        } else if (!component.options || component.options.length < 1) {
          errors.push(`Checkbox in screen ${index + 1} must have at least 1 option`);
        }
      }
    });

    if (screen.next_step_id && screen.next_step_id === screen.id) {
      errors.push(`Screen "${screen.id}" cannot navigate to itself`);
    }

    if (isDynamic) {
      const hasDynamicFields = (screen.components || []).some(
        (component) => component.data_mode === 'dynamic'
      );
      if (hasDynamicFields && !screen.tenant_api_uri?.trim()) {
        errors.push(
          `Screen "${screen.title || screen.id}" has dynamic content but no tenant API endpoint`
        );
      }
    }
  });

  return errors;
};
